var render = function render(_c,_vm){return _c('svg',_vm._g({class:_vm.props.className,attrs:{"aria-hidden":"true"}},_vm.listeners),[_c('use',{attrs:{"xlink:href":`#${_vm.props.xlink.replace('#','')}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }